import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { Link, Redirect } from "react-router-dom";

import { linkNewEmail } from "../audiblogsApi";
import userStore from "../Stores/User";
import { observer } from "mobx-react";

const LinkEmail = observer((props) => {
  const { user, idToken, isSignedIn } = userStore;
  const params = queryString.parse(props.location.search);
  const [redirectTo, setRedirectTo] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    if (isSignedIn === false) {
      // If not signed in, redirect to signin
      setRedirectTo(
        `/signin?redirected_from=link&email=${encodeURIComponent(params.email)}`
      );
    }
  }, [isSignedIn]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <div class="center">
      <div></div>

      <div>
        {!isConfirmed ? (
          <div>
            <div>
              {params &&
                user &&
                `Please confirm that you would like to link ${params.email} to your
      existing Audiblogs account, ${user.email}`}
            </div>
            <button
              onClick={(e) => {
                linkNewEmail(idToken, params.email).then((res) => {
                  console.log(res);
                  setIsConfirmed(true);
                });
              }}
            >
              Confirm
            </button>
          </div>
        ) : (
          `Done! Please try forwarding an email from ${params.email}`
        )}
      </div>
    </div>
  );
});

export default LinkEmail;
